// src/components/Header/Logo.jsx
import { Link } from "react-router-dom";

import { Image } from "common";

export default function Logo() {
  return (
    <Link
      to="/"
      aria-label="Dens 'N Dente home"
      className="shrink-0 rounded-sm focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
    >
      <Image
        src="/logo.png"
        alt="Dens 'N Dente Healthcare"
        className="block h-[40px] w-auto"
      />
    </Link>
  );
}
